export const environment = {
  production: false,
  projectName: "CTSolutionManager",
  dev: {
    REST_API_SERVER: "https://ctmanager.demo.api.testctsolution.it/api"
  },
  variables: {
    defaults: {}
  },
  customTranslationsDirectory: '/assets/custom-translations',
  defaultLang: 'it'
};
